module.exports = "<app-header></app-header>\n<div class=\"app-body\">\n  <app-app-admin-sidebar></app-app-admin-sidebar>\n  <!-- Main content -->\n  <main class=\"main\">\n    <!-- Breadcrumb -->\n    <ol class=\"breadcrumb\">\n      <app-breadcrumbs></app-breadcrumbs>\n    </ol>\n    <div class=\"container-fluid\">\n      <router-outlet></router-outlet>\n    </div><!-- /.conainer-fluid -->\n  </main>\n  <app-aside></app-aside>\n</div>\n<app-footer></app-footer>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/containers/admin-layout/admin-layout.component.html
// module id = ./src/app/containers/admin-layout/admin-layout.component.html
// module chunks = main